import React, { useRef } from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

const FullCalendarView = ({ events, handleDateClick, initialView = 'dayGridMonth', selectable = true, onDatasetChange }) => {
  const calendarRef = useRef()
  const handleDataSetChange = (arg) => {
    onDatasetChange && onDatasetChange(arg)
    const button = document.querySelector('.fc-yearButton-button')
    const isYearView = arg.view.type === 'yearView'
    if (isYearView) {
      button.classList.add('fc-button-active')
    } else {
      button.classList.remove('fc-button-active')
    }
  }

  const handleYearButtonClick = () => {
    const calendarApi = calendarRef?.current?.getApi()
    calendarApi?.changeView('yearView')
  }

  const customViews = {
    yearView: {
      type: 'dayGrid',
      duration: { years: 1 },
      buttonText: 'Year',
      date: new Date().getFullYear(),
      eventRender: events
    }
  }

  return (
    <FullCalendar
      ref={calendarRef}
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
      initialView={initialView}
      displayEventTime={false}
      views={customViews}
      headerToolbar={{
        left: 'prev,next',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,yearButton'
      }}
      customButtons={{
        yearButton: {
          text: 'Year',
          click: function () {
            handleYearButtonClick(this)
          }
        }
      }}
      selectable={selectable}
      dayMaxEvents={true}
      eventResizableFromStart={false}
      dragScroll={false}
      eventStartEditable={false}
      navLinks={true}
      eventDisplay="block"
      events={events}
      eventClick={handleDateClick}
      dateClick={handleDateClick}
      datesSet={(arg) => handleDataSetChange(arg)}
    />
  )
}

export default FullCalendarView
